import type { OrderDiff, WorkspaceItem } from '../types'

const isMoved = (f: WorkspaceItem, i: number) => f.order !== i

export const getOrdersDiff = (folders: WorkspaceItem[]) =>
  folders
    .filter((f) => f.type === 'folder')
    .reduce((accum, folder, i) => {
      if (isMoved(folder, i)) {
        accum.push({ ...folder, order: i })
      }

      return accum
    }, [] as OrderDiff[])
